import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { FormViewType } from '../../Tickets';
import { StorageItems } from '../../../../../utils/storageItems';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import { darkModeBackgroudInputs } from '../../../../../utils/constants';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { ModuleType } from '../../../Assets/Components/Header/CardHeader';

interface LayoutSelectProps {
    module: ModuleType;
    formView: FormViewType;
    size: 'small' | 'medium';
    setFormView: React.Dispatch<React.SetStateAction<FormViewType>>;
}

export const LayoutSelect: React.FC<LayoutSelectProps> = ({ module, size, formView, setFormView }) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    const handleChange = (e: SelectChangeEvent<"CardView" | "TableView">) => {
        const { value } = e.target;
        const upFormView = value as FormViewType;
        setFormView(upFormView);
        if (module === 'Tickets') {
            localStorage.setItem(StorageItems.TicketView, upFormView);
        } else if (module === 'Assets') {
            localStorage.setItem(StorageItems.AssetView, upFormView);
        }
    }

    return <FormControl size={size} fullWidth>
        <InputLabel
            id="layout-select"
            sx={darkMode ? { color: 'white' } : {}}
        >
            Layout
        </InputLabel>
        <Select
            id="layout-select"
            labelId="layout-select"
            value={formView}
            sx={{
                color: darkMode ? 'white' : 'black',
                '& .MuiSelect-icon': {
                    color: darkMode ? 'white' : 'black',
                },
            }}
            label="Layout"
            onChange={handleChange}
            MenuProps={{
                PaperProps: {
                    sx: {
                        color: darkMode ? 'white' : 'black',
                        backgroundColor: darkMode ? darkModeBackgroudInputs : 'white',
                    },
                },
            }}
        >
            <MenuItem value='CardView'>{language["CardView"]}</MenuItem>
            <MenuItem value='TableView'>{language["TableView"]}</MenuItem>
        </Select>
    </FormControl>
}
export default LayoutSelect